import React, { useState, useEffect } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Row, Col, Card, CardBody, Form, Spinner } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import {
  putRequestForm,
  postRequest,
  postRequestForm,
} from "components/Common/Utils.js";
import Lightbox from "react-image-lightbox";

export default function FaqCreate() {
  const location = useLocation();
  const state = location.state?.row;
  const [FAQ, setFAQ] = useState(null);
  const [previewImage, setPreviewImage] = useState("");
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [model, setModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [startLoader, setStartLoader] = useState(false);

  let history = useHistory();

  const UpdatedCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    const payload = {
      question : FAQ?.question,
      answer : FAQ?.answer,
      isPublished : FAQ?.isPublished,
      isDeleted : FAQ?.isDeleted,
    }
    const response = await postRequest(
      "support/quick-question/add",
      payload
    );
    setLoading(false);
    if (response.status == 1) {
      toast.success(response.message);
      setTimeout(() => {
        history.goBack();
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const updateValue = (index, value) => {
    const list = { ...FAQ };
    list[index] = value;
    setFAQ(list);
  };

  return (
    <React.Fragment>
      <ToastContainer />

      <div className="row">
        <div className="col-lg-10">
          <div className="page-title-box">
            <h4>FAQ Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">FAQ Management</li>:{" "}
              <li className="breadcrumb-item">Create FAQ</li>
            </ol>
          </div>
        </div>
        <div class="col-md-2 text-end">
          <button
            type="button"
            onClick={() => history.goBack()}
            className="btn btn-primary btn-lg"
          >
            <i class="fas fa-chevron-left"></i> Back
          </button>
        </div>
      </div>
      <Row>
        <Col lg={12}>
          <Card>
            {loading ? (
              <CardBody style={{ height: "100px" }}>
                <Spinner
                  color="info"
                  style={{
                    height: "4rem",
                    width: "4rem",
                    position: "absolute",
                    left: "50%",
                  }}
                >
                  Loading...
                </Spinner>
              </CardBody>
            ) : (
              <CardBody>
                <h4 className="card-title"> Create FAQ</h4>
                <Form onSubmit={UpdatedCategory}>
                  <Row>
                    <Col lg={12} className="ms-lg-auto">
                      <div className="mt-5 mt-lg-4">
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">
                            Title
                          </label>
                          <div className="col-sm-6">
                            <input
                              type="text"
                              onChange={(e) =>
                                updateValue("question", e.target.value)
                              }
                              value={FAQ?.question}
                              name="question"
                              className="form-control"
                            />
                          </div>
                        </div>
                        <div className="row mb-4">
                          <label htmlFor="ispublisd"></label>
                        </div>
                        <div className="row mb-4">
                          <label className="col-sm-3 col-form-label">
                            Description
                          </label>
                          <div className="col-sm-6">
                            <textarea
                             style={{height : '150px'}}
                             row={10}
                              onChange={(e) =>
                                updateValue("answer", e.target.value)
                              }
                              value={FAQ?.answer}
                              name="answer"
                              className="form-control"
                            />
                          </div>
                        </div>

                      

                        <div className="mt-5 mt-lg-4">
                          <div className="row justify-content-end">
                            <div className="col-sm-9">
                              <div>
                                <button
                                  type="submit"
                                  className="btn btn-primary w-md"
                                >
                                  Submit
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            )}
          </Card>
        </Col>
      </Row>
      {openLightbox && (
        <Lightbox
          mainSrc={previewImage}
          onCloseRequest={() => setOpenLightBox(false)}
        />
      )}

    </React.Fragment>
  );
}
